import MemoryMinigame from "./components/MemoryMinigame";

const index = () => {
  return (
    <div>
      <MemoryMinigame />
    </div>
  );
};

export default index;
